import { render, staticRenderFns } from "./Space.vue?vue&type=template&id=89f92b54&"
import script from "./Space.vue?vue&type=script&lang=js&"
export * from "./Space.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports